import { C } from "../data/content";
import { RegistrationForm } from "./RegistrationForm";

const trust = [
  "100% free educational event — no cost, ever",
  "No hard credit pull required to attend",
  "Not a loan application — zero obligation",
  "Live Q&A with Darren, licensed in FL, TX & PA",
];

export const FinalRegister = ({ attribution }) => (
  <section id="register" className="relative py-32 px-6 lg:px-12 grid-bg overflow-hidden" style={{ background: "rgba(255,255,255,0.012)" }} data-testid="final-register-section">
    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(68,76,231,0.16), transparent 65%)" }} />
    <div className="relative max-w-[1200px] mx-auto grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-8">[009] — RESERVE YOUR SEAT</p>
        <h2 className="h1-display text-[clamp(36px,4.6vw,64px)]">
          YOUR NEXT MOVE STARTS WITH A CLEARER <span className="text-[var(--accent)]">MAP.</span>
        </h2>
        <ul className="mt-10 space-y-4">
          {trust.map((t, i) => (
            <li key={i} className="flex gap-3 items-start text-[14px] text-white/60" data-testid={`trust-bullet-${i + 1}`}>
              <span className="text-[var(--accent)] font-black">✓</span>{t}
            </li>
          ))}
        </ul>
      </div>
      <div className="max-w-[460px] w-full lg:ml-auto">
        <RegistrationForm attribution={attribution} idPrefix="final" showBonuses={false} />
      </div>
    </div>
  </section>
);
